import type { QueryClient } from '@tanstack/react-query';

/** Run only on a confirmed identity transition, not a transient auth failure. */
export function clearPrivateQueries(client: QueryClient): void {
  client.removeQueries({ predicate: query => query.queryKey[0] !== 'app-config' });
}